import { useNavigate } from 'react-router-dom';
import { useStore } from '../../store';
import { Button, ProgressBar } from '../../components/ui';
import { RadarChart } from './Week1Screen';
import { motion } from 'framer-motion';

export function Week10Screen() {
  const navigate = useNavigate();
  const { nextStep } = useStore();

  const handleContinue = () => {
    nextStep();
    navigate('/onboarding/comparison');
  };

  // High values for Week 10
  const week10Values = [85, 78, 90, 82, 88];

  return (
    <div className="screen-container onboarding-screen">
      <ProgressBar current={13} total={17} className="mb-8" />

      <div className="flex-1 flex flex-col">
        <h1 className="text-3xl font-bold mb-8">Week 10</h1>

        <div className="flex-1 flex flex-col items-center justify-center">
          <RadarChart values={week10Values} size={240} />

          <motion.div
            className="mt-8 text-center space-y-3"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8, duration: 0.5 }}
          >
            <p className="text-3xl md:text-4xl font-semibold">
              Week 10 is where the glow-up becomes obvious.
            </p>
            <p className="text-3xl md:text-4xl text-accent font-semibold">
              You're not the same guy anymore.
            </p>
          </motion.div>
        </div>
      </div>

      <Button onClick={handleContinue}>
        Continue
      </Button>
    </div>
  );
}
